import config from "../config"
const base_url = config.base_url
export const sendLoginOTPCodeEmail = (token) =>{
    return fetch(base_url+'login/OTP/RequestNewMFA', {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-type': 'application/x-www-form-urlencoded',
            'credentials':'include'
        },
        body: `token=${token}`,
        credentials:'include'
    })
}